import React, { PureComponent } from 'react';
import Loadable from 'react-loadable';
import Loader from '../Loader/Loader';
import { isPreRendering } from '../../common/utils';

export default class KlickLoadable extends PureComponent {
  render = () => {
    const { componentName, componentNameActual, ...restProps } = this.props;

    const LoadableComponent = isPreRendering
      ? Loader
      : Loadable({
          loader: () => import(`../Fold/Fold`),
          loading: Loader,
        });

    return <LoadableComponent {...restProps} />;
  };
}
